// lib/utils/notice/noticeUtils.js

/* ──────────────────────────────────────────────────────────────
 * ✅ Notice 유틸 모음
 *  - safeStr: 안전한 문자열 변환
 *  - clamp: 범위 제한
 *  - formatKoreanDateTime: 한국식 날짜/시간 문자열
 *  - isPinnedActive: pinned + pin_until 기준으로 "현재 고정 유효" 판정
 * ────────────────────────────────────────────────────────────── */

export function safeStr(v) {
  if (typeof v === "string") return v;
  if (v === null || v === undefined) return "";
  return String(v);
}

export function clamp(n, min, max) {
  const num = Number(n);
  const a = Number(min);
  const b = Number(max);
  if (!Number.isFinite(num)) return a;
  return Math.max(a, Math.min(b, num));
}

function toDate(v) {
  if (!v) return null;
  if (v instanceof Date) return Number.isNaN(v.getTime()) ? null : v;

  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}

/**
 * ✅ 날짜/시간 표시 (ko-KR)
 * - input: Date | string | number | null
 * - output: "2026. 02. 02. 오전 11:06" 같은 형태
 */
export function formatKoreanDateTime(v) {
  return formatLocaleDateTime(v, "ko-KR");
}

export function formatLocaleDateTime(v, locale = "ko-KR") {
  const d = toDate(v);
  if (!d) return "-";

  return d.toLocaleString(locale || "ko-KR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/**
 * ✅ 고정 유효 여부
 * - pinned=1 이면서
 *   - pin_until이 null이면 무기한 고정
 *   - pin_until이 현재보다 미래(또는 동일)면 고정 유지
 */
export function isPinnedActive(item, now = new Date()) {
  const pinned = Number(item?.pinned ?? 0) === 1;
  if (!pinned) return false;

  const until = toDate(item?.pin_until);
  if (!until) return true;

  const nowDate = toDate(now) ?? new Date();
  return until.getTime() >= nowDate.getTime();
}
